export default __webpack_public_path__ + "static/media/Colleen_Santini_AHV_In_Moms_We_Trust.e03a6056.jpg";